export const pageMainQueryKey = "pages";
